import { render, staticRenderFns } from "./AboutUsNew.vue?vue&type=template&id=55ddec60&scoped=true"
import script from "./AboutUsNew.vue?vue&type=script&lang=js"
export * from "./AboutUsNew.vue?vue&type=script&lang=js"
import style0 from "./AboutUsNew.vue?vue&type=style&index=0&id=55ddec60&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ddec60",
  null
  
)

export default component.exports